export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'Container', 
              name: 'Container Selos',
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsStamps2', 
                },
                
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};